/**
 * The collapsed "Technical details" disclosure that rides under a friendly
 * error line — the raw wire message (see ActionResult.detail in
 * lib/actions.ts), reachable for whoever maintains this but never the
 * headline. Renders nothing when there is no detail, so callers can drop it
 * in unconditionally. Same shape as the ErrorBoundary fallback's own
 * disclosure, kept identical on purpose so every "something went wrong" in
 * the app reads the same way.
 */
export function TechnicalDetails({ detail }: { detail?: string | null }) {
  if (!detail) return null;
  return (
    <details style={S.details}>
      <summary style={S.summary}>Technical details</summary>
      <code style={S.code}>{detail}</code>
    </details>
  );
}

const S = {
  details: { marginTop: '0.45rem', fontSize: '0.8rem', color: '#555', fontWeight: 400 },
  // Vertical padding lifts the <summary> to a ~44px target (not display:flex,
  // which would drop the native disclosure triangle) — same as ErrorBoundary.
  summary: { cursor: 'pointer', padding: '0.85rem 0' },
  code: {
    display: 'block',
    marginTop: '0.35rem',
    padding: '0.4rem 0.55rem',
    borderRadius: '0.35rem',
    background: 'rgba(255, 255, 255, 0.7)',
    color: '#444',
    fontSize: '0.76rem',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
  },
} satisfies Record<string, React.CSSProperties>;
